import { Tooltip as AntTooltip, TooltipProps } from "antd";
import styled from "styled-components";

export const Tooltip: typeof AntTooltip = styled(AntTooltip)<TooltipProps>``;
